import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=66f7eaf8&scoped=true&"
import script from "./reset_password.vue?vue&type=script&lang=js&"
export * from "./reset_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7eaf8",
  null
  
)

export default component.exports